import './ResultsTree.scss';

import { bem } from 'mission-control-common-components';
import React from 'react';

import type { TagSheetParseResult, TagSheetSaveResult } from '../../types';
import { getLineItemHeaderDisplay } from '../utils';
import LineItemResultGroup from './LineItemResultGroup/LineItemResultGroup';

const [block] = bem('results-tree');

export type ResultsTreeProps = {
  lineItems: TagSheetSaveResult['lineItems'];
  parseResult: TagSheetParseResult | null;
};

const ResultsTree = ({ lineItems, parseResult }: ResultsTreeProps): React.JSX.Element => (
  <div className={block()} data-testid="results-tree">
    {lineItems.map(({ lineItemId, ads }) => (
      <LineItemResultGroup
        key={lineItemId}
        groupId={lineItemId}
        headerDisplay={getLineItemHeaderDisplay(parseResult, lineItemId)}
        ads={ads}
      />
    ))}
  </div>
);

export default ResultsTree;
